// Copyright (c) 2026 WiseTime. All rights reserved.

// Deferred store.dispatch to break the circular dependency between rpc.ts and store.ts.
//
// The cycle: rpc.ts ← epics ← store.ts ← rpc.ts
//   - store.ts imports every feature epic (for combineEpics)
//   - each epic imports from rpc.ts (for gRPC service clients and executors)
//   - rpc.ts needs store.dispatch (for onRefreshSuccess and stream error handling)
//
// Fix: store.ts registers its dispatch function here after creation,
// and rpc.ts calls storeDispatch() at runtime — no direct import of store.ts needed.

import { Action } from "redux"

let _dispatch: ((action: Action) => void) | undefined

export const setStoreDispatch = (fn: (action: Action) => void): void => { _dispatch = fn }
export const storeDispatch = (action: Action): void => _dispatch?.(action)
